import { ChipProps } from '@mui/material';
import {
  ISchoolMonitoringEventSimpleProps,
} from './types';

export enum SchoolMonitoringType {
  STUDENT = 'STUDENT',
  RESPONSIBLE = 'RESPONSIBLE',
}

interface IEventTargetData {
  name: string;
  image: string;
  typeLabel: string;
  color: ChipProps['color']; 
  className?: string | null;
}

export const getEventTargetData = (event: ISchoolMonitoringEventSimpleProps): IEventTargetData => {
  if (!event) 
    return { name: '', image: '', typeLabel: '', color: 'default', className: '-' };

  const isStudent = 
    event.schoolMonitoringType === SchoolMonitoringType.STUDENT || 
    event.schoolMonitoringType === 0;

  if (isStudent) {
    return { 
      name: event.studentRecognition?.name || 'common.unknown',
      image: event.studentRecognition?.image || '', 
      typeLabel: 'common.student', 
      color: 'success',
      className: event.studentRecognition?.className || 'common.none'
    };
  }
  
  return { 
    name: event.responsible?.name || 'common.unknown',
    image: event.responsible?.image || '',
    typeLabel: 'common.responsible', 
    color: 'primary', 
    className: 'common.notApplicable'
  };
};